/**
 * Delivering a register document to the browser.
 *
 * Two details here are load-bearing and were learned the hard way on the
 * company detail page, which is why they live in one place instead of being
 * re-derived per surface:
 *
 * 1. **The tab must be opened synchronously inside the click handler.** By
 *    the time the presigned URL comes back from the API, the user gesture has
 *    expired and `window.open` is blocked as a popup.
 * 2. **TIFF cannot be rendered by browsers.** Register scans are sometimes
 *    TIFF; pointing a tab at one leaves the user staring at a download
 *    prompt behind a blank page, so those are handed to the download path
 *    and the placeholder tab is closed.
 */

/** Open a placeholder tab now, so the real URL can be dropped in later. */
export function openPendingTab(loadingLabel = 'Dokument wird geladen...'): Window | null {
  const tab = window.open('about:blank', '_blank');
  if (tab) {
    tab.document.title = 'Laden...';
    tab.document.body.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:system-ui;color:#666"><p>${loadingLabel}</p></div>`;
  }
  return tab;
}

/** Point the placeholder tab at the document — or download it if it's a TIFF. */
export function deliverToTab(tab: Window | null, url: string): void {
  if (/\.tiff?(\?|$)/i.test(url)) {
    tab?.close();
    const a = document.createElement('a');
    a.href = url;
    a.download = '';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  }
  if (tab) tab.location.href = url;
  else window.open(url, '_blank', 'noopener,noreferrer');
}
